// extracted by mini-css-extract-plugin
module.exports = {"container":"outRecipe_container__39uFK","wrap":"outRecipe_wrap__1VzK2"};